/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */

export type InvoiceReportOrderByField =
  (typeof InvoiceReportOrderByField)[keyof typeof InvoiceReportOrderByField];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceReportOrderByField = {
  number: 'number',
  created_date: 'created_date',
  submitted_date: 'submitted_date',
  invoice_book_date: 'invoice_book_date',
  invoice_due_date: 'invoice_due_date',
  approved_date: 'approved_date',
  payment_date: 'payment_date',
} as const;
